import React, { useState, useEffect } from "react";
import {
  Form,
  Button,
  Container,
  Row,
  Col,
  Modal,
  Nav,
  BreadcrumbItem,
  Breadcrumb,
  InputGroup,
  Table,
} from "react-bootstrap";
import { toast } from "react-toastify";
import { useGetformMutation } from "../../slices/formApiSlice";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import {
  useGetEmployeeListMutation,
  useGetOptionsMutation,
} from "../../slices/commonApiSlice";
import { parseOptionsData } from "../../utils/parseOptionsData";
import { parseUserInfo } from "../../utils/parseUtil";
import { Typeahead } from "react-bootstrap-typeahead";
import "react-bootstrap-typeahead/css/Typeahead.css";
import { useGetAttendanceMutation } from "../../slices/adminApiSlice";
import { FaSortDown, FaSortUp } from "react-icons/fa";

const AttendanceRegisterFormScreen = () => {
  const [month, setMonth] = useState("");
  const [year, setYear] = useState("");
  const [empType, setEmpType] = useState("");
  const [empName, setEmpName] = useState("");
  const [department, setDepartment] = useState("");
  const [designation, setDesignation] = useState("");
  const [empCode, setEmpCode] = useState("");
  const [language, setLanguage] = useState("0");
  const [showModal, setShowModal] = useState(false);
  const [pdfUrl, setPdfUrl] = useState("");
  const [employeeSuggestions, setEmployeeSuggestions] = useState([]);
  const [selectedEmpCode, setSelectedEmpCode] = useState("");
  const [contractor, setContractor] = useState("");
  const [report, setReport] = useState("1"); // Default value for report
  const [sortBy, setSortBy] = useState("DOFJOIN");
  const [isAscending, setIsAscending] = useState(true);
  const [yearsOptions, setYearsOptions] = useState([]);
  const [chkwd, setChkwd] = useState("1");
  const [chkhd, setChkhd] = useState("1");
  const [chkwo, setChkwo] = useState("1");
  const [chkcl, setChkcl] = useState("1");
  const [chkel, setChkel] = useState("1");
  const [chksl, setChksl] = useState("1");
  const [sort, setSort] = useState("0");
  const [desc, setDesc] = useState("0");
  const [showSalary, setShowSalary] = useState("0");
  const [headOne, setHeadOne] = useState("FORM No. 12");
  const [headTwo, setHeadTwo] = useState("( RULE NO 78)");
  const [headThree, setHeadThree] = useState(
    "Register of Adult Worker Prescribed under section 62 of the Act "
  );
  const [headFour, setHeadFour] = useState("");
  const [comMondayToFriday, setComMondayToFriday] = useState("09:00");
  const [fromMondayToFriday, setFromMondayToFriday] = useState("09:00");
  const [toMondayToFriday, setToMondayToFriday] = useState("17:30");
  const [comSaturday, setComSaturday] = useState("09:00");
  const [fromSaturday, setFromSaturday] = useState("09:00");
  const [toSaturday, setToSaturday] = useState("17:30");
  const [systemRotationRelays, setSystemRotationRelays] = useState("1");
  const [fromMondayToFridaySecond, setFromMondayToFridaySecond] = useState("13:30");
  const [toMondayToFridaySecond, setToMondayToFridaySecond] = useState("17:30");
  const [compMondayToFridaySecond, setCompMondayToFridaySecond] = useState("17:30");
  const [fromSaturdaySecond, setFromSaturdaySecond] = useState("13:30");
  const [toSaturdaySecond, setToSaturdaySecond] = useState("17:30");
  const [compSaturdaySecond, setCompSaturdaySecond] = useState("17:30");
  const [ddlReportType, setDdlReportType] = useState("0");
  const [showAttRcd, setShowAttRcd] = useState("0");
  const [showSalaryDetailChk,setShowSalaryDetailChk]=useState(true)
  const [showOnlySalarySheetChk,setShowOnlySalarySheetChk]=useState(false)
  const [monthString,setMonthString]=useState("")

  const { userInfo } = useSelector((state) => state.auth);

  const [getAttendance, { isLoading }] = useGetAttendanceMutation();
  const [getOptions, { isLoading: getOptionsLoading }] =
    useGetOptionsMutation();
  const [getEmpName, { isLoading: getEmpNameLoading }] =
    useGetEmployeeListMutation();

  const [employeeTypes, setEmployeeTypes] = useState([]);
  const [designations, setDesignations] = useState([]);
  const [departments, setDepartments] = useState([]);

  // Helper Function
  //   const parseUserInfo = (res) => {

  //     if (res?.data) {
  //       try {
  //         return JSON.parse(res.data);
  //       } catch (e) {
  //         console.error("Failed to parse JSON:", res.data);
  //         return null;
  //       }
  //     } else if (res?.data?.Error) {
  //       toast.error(res.data.Error);
  //     }
  //     return null;
  //   };

  const monthNames = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ];

  useEffect(() => {
    const now = new Date();
    const currentYear = now.getFullYear();
    const currentMonth = now.getMonth() + 1;
    const previousMonth = currentMonth === 1 ? 12 : currentMonth - 1;

    const startYear = parseInt(process.env.REACT_APP_START_YEAR || "2020", 10);

    const options = [];
    for (let i = startYear; i <= currentYear + 1; i++) {
      options.push(i);
    }

    setYearsOptions(options);
    setYear(currentYear.toString());
    setMonthString(monthNames[previousMonth-1])
    setMonth(previousMonth.toString());

    // Fetch options data on component load
    const fetchOptions = async () => {
      try {
        const reqCompanyCode = userInfo[13]?.InfoField || "1"; // Default to '1' if not available

        const formData = new FormData();
        formData.append("title", "GetEmployeeMasterDataList");
        formData.append("ReqCompanyCode", reqCompanyCode);

        const res = await getOptions(formData);

        const parsedOptions = parseUserInfo(res);

        if (parsedOptions && parsedOptions[0]?.JSONData1) {
          try {
            const parsedData = JSON.parse(parsedOptions[0]?.JSONData1);
            const employeeTypes = parsedData.map((item) => item.EmployeeType);

            setEmployeeTypes(employeeTypes || []);
            setDesignations(parsedData.designations || []);
            setDepartments(parsedData.departments || []);
          } catch (parseError) {
            console.error("Error parsing JSONData1:", parseError);
            toast.error("Failed to load options due to parsing error");
          }
        } else {
          toast.error("Failed to load options");
        }
      } catch (err) {
        console.error("Error fetching options:", err);
        toast.error("Error fetching options");
      }
    };

    fetchOptions();
  }, [getOptions, userInfo]);


  

  const handleSortOrderToggle = () => {
    setIsAscending(!isAscending);
    setDesc(isAscending ? "0" : "1");
  };


  const handleReportChange=(e)=>{
    
    const value = parseInt(e.target.value);
    setReport(value);

    
    if (value === 1 || value === 0) {
        setHeadOne('FORM No. 12');
        setHeadTwo('(RULE NO 78)');
        setHeadThree('Register of Adult Worker Prescribed under section 62 of the Act');
        setHeadFour('');
      } else if (value === 2) {
        setHeadOne('Form -XVI [See Rule 78(1)(a)(ii)]');
        setHeadTwo('MUSTER ROLL');
        setHeadThree('');
        setHeadFour('');
      } else if (value === 3) {
        setHeadOne('FORM XVI');
        setHeadTwo('[See Rule 78(1)a(i)]');
        setHeadThree('MUSTER ROLL');
        setHeadFour('(FOR CONTRACTOR EMPLOYEES)');
      } else if (value === 4) {
        setHeadOne('ATTENANCE REGISTER');
        setHeadTwo('');
        setHeadThree('');
        setHeadFour('');
      } else if (value === 5) {
        setHeadOne('Form No. 26');
        setHeadTwo('(Prescribed under Rule 103)');
        setHeadThree('MUSTER ROLL');
        setHeadFour('');
      }

  }

  const handleEmployeeSearch = async (input) => {
    if (input.length < 3) {
      setEmployeeSuggestions([]); // Clear suggestions if input is less than 3 characters
      return;
    }

    try {
      const reqCompanyCode = userInfo[13]?.InfoField || "1"; // Default to '1' if not available
      const formData = new FormData();
      formData.append("title", "GetEmployeeList");
      formData.append("ReqCompanyCode", reqCompanyCode);
      formData.append("ReqSearchStr", input);

      const res = await getEmpName(formData);
      const parsedData = parseUserInfo(res);

      if (parsedData && parsedData.length > 0) {
        const employeeList = JSON.parse(parsedData[0].JSONData1);
        setEmployeeSuggestions(employeeList);
      } else {
        setEmployeeSuggestions([]);
        toast.error("No employees found");
      }
    } catch (err) {
      console.error("Error fetching employee list:", err);
      toast.error("Error fetching employee list");
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const reqCompanyCode = userInfo[13]?.InfoField;
    const reqEmpCode = empCode;

    const formData = new FormData();
    formData.append("title", "GetForm12AReport");
    formData.append("ReqDDLMonths", monthString);
    formData.append("DDLMonthsNdx", month);
    formData.append("ReqTxtYear", year);
    formData.append("ReqTxtCode", reqEmpCode);
    formData.append("ReqDDLType", empType);
    formData.append("Reqtxtcontname", contractor);
    formData.append("ReqCompanyCode", reqCompanyCode);
    formData.append("ReqChkWD", chkwd);
    formData.append("ReqChkHD", chkhd);
    formData.append("ReqChkWO", chkwo);
    formData.append("ReqChkCL", chkcl);
    formData.append("ReqChkEL", chkel);
    formData.append("ReqChkSL", chksl);
    formData.append("ReqDDLSortCol", sortBy);
    formData.append("ReqChkDesc", desc);
    formData.append("ReqChkShowSalary", showSalaryDetailChk?"1":"0");
    formData.append("ReqTxtHD1", headOne);
    formData.append("ReqTxtHD2", headTwo);
    formData.append("ReqTxtHD3", headThree);
    formData.append("ReqTxtHD4", headFour);
    formData.append("ReqTxtComMF", comMondayToFriday);
    formData.append("ReqTxtFRMMF", fromMondayToFriday);
    formData.append("ReqTxtToMF", toMondayToFriday);
    formData.append("ReqTxtComSat", comSaturday);
    formData.append("ReqTXTFRMSAT", fromSaturday);
    formData.append("ReqTXTTOSAT", toSaturday);
    formData.append("ReqTxtSRR", systemRotationRelays);
    formData.append("ReqTxtFromAFMF", fromMondayToFridaySecond);
    formData.append("ReqTxtToAFMF", toMondayToFridaySecond);
    formData.append("ReqTxtCompMF", compMondayToFridaySecond);
    formData.append("ReqTxtFromAFSat", fromSaturdaySecond);
    formData.append("ReqTxtToAFSat", toSaturdaySecond);
    formData.append("ReqTxtCompSat", compSaturdaySecond);
    formData.append("ReqDDLReportType", report);
    formData.append("ReqChkShowAttRcd", showOnlySalarySheetChk?"1":"0");
    

    for (let [key, value] of formData.entries()) {
      console.log(`${key}: ${value}`);
    }

    try {
      const res = await getAttendance(formData);

      const parsedData = parseUserInfo(res);

      if (parsedData && Array.isArray(parsedData) && parsedData.length > 0) {
        const data = parsedData[0];

        if (data.ErrorCode === "0") {
          let pdfPath = data.JSONData1;

          if (pdfPath.startsWith("/api/WebServiceForStaffData.aspx/")) {
            pdfPath = pdfPath.replace("/api/WebServiceForStaffData.aspx/", "/");
          }

          const backendUrl = process.env.REACT_APP_URL;
          const pdfUrl = `${backendUrl}${pdfPath}`;

          const anchor = document.createElement("a");
          anchor.href = pdfUrl;
          anchor.download = pdfPath.split("/").pop(); // Use the filename from the URL
          document.body.appendChild(anchor);
          anchor.click();
          document.body.removeChild(anchor);

          setPdfUrl(pdfUrl);
          // setShowModal(true);
        } else {
          toast.error(data.ErrorMessage || "An error occurred");
        }
      } else {
        toast.error("Failed to parse user info");
      }
    } catch (err) {
      console.error("Error submitting data:", err);
      toast.error(err?.data?.message || "Error submitting data");
    }
  };

  return (
    <>
      <Breadcrumb>
        <BreadcrumbItem>
          <Nav.Link
            as={Link}
            to="/dashboard"
            className="text-success text-decoration-none"
          >
            Dashboard
          </Nav.Link>
        </BreadcrumbItem>
        <BreadcrumbItem active>Attendance Register Form - 12</BreadcrumbItem>
      </Breadcrumb>
      <Container className="">
        <h4 className="text-center">Attendance Register Form - 12</h4>

        <Col>
          <Row>
            <Form
              className="border p-4 rounded bg-light mb-4"
              onSubmit={handleSubmit}
            >
              <Row className="mb-3">
                {/* First Row */}
                <Col md={3}>
                  <Form.Group controlId="empName">
                    <Form.Label>Employee Name</Form.Label>
                    <Typeahead
                      id="empName-typeahead"
                      onInputChange={(input) => {
                        setEmpName(input);
                        handleEmployeeSearch(input);
                      }}
                      onChange={(selected) => {
                        if (selected.length > 0) {
                          setEmpName(selected[0].EmployeeName);
                          setSelectedEmpCode(selected[0].Empcode); // Save the employee code
                          setEmpCode(selected[0].Empcode);
                        }
                      }}
                      options={employeeSuggestions}
                      labelKey="EmployeeName"
                      placeholder="Choose an employee..."
                      selected={empName ? [{ EmployeeName: empName }] : []}
                      className="form-control-hover"
                      minLength={3}
                      // required
                    />
                  </Form.Group>
                </Col>
                <Col md={3}>
                  <Form.Group controlId="month">
                    <Form.Label>Month</Form.Label>
                    <Form.Control
                      as="select"
                      value={month}
                      onChange={(e) => {
                        const selectedValue = e.target.value; // Get the value (1, 2, 3, etc.)
                        const selectedName = e.target.options[e.target.selectedIndex].text; // Get the name (January, February, etc.)
                        setMonth(selectedValue); 
                        setMonthString(selectedName)
                        
                      }}
                      className="form-control-hover"
                    >
                      <option value="1">January</option>
                      <option value="2">February</option>
                      <option value="3">March</option>
                      <option value="4">April</option>
                      <option value="5">May</option>
                      <option value="6">June</option>
                      <option value="7">July</option>
                      <option value="8">August</option>
                      <option value="9">September</option>
                      <option value="10">October</option>
                      <option value="11">November</option>
                      <option value="12">December</option>
                    </Form.Control>
                  </Form.Group>
                </Col>
                <Col md={3}>
                  <Form.Group controlId="year">
                    <Form.Label>Year</Form.Label>
                    <Form.Control
                      as="select"
                      value={year}
                      onChange={(e) => setYear(e.target.value)}
                      className="form-control-hover"
                      required
                    >
                      {yearsOptions.map((yr) => (
                        <option key={yr} value={yr}>
                          {yr}
                        </option>
                      ))}
                    </Form.Control>
                  </Form.Group>
                </Col>
                <Col md={3}>
                  <Form.Group controlId="empCode">
                    <Form.Label>Employee Code</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Enter Employee Code"
                      value={empCode}
                      onChange={(e) => setEmpCode(e.target.value)}
                      className="form-control-hover"
                    />
                  </Form.Group>
                </Col>
              </Row>

              <Row className="mb-3">
                {/* Second Row */}
                <Col md={3}>
                  <Form.Group controlId="empType">
                    <Form.Label>Employee Type</Form.Label>
                    <Typeahead
                      id="empType-typeahead"
                      onChange={(selected) => setEmpType(selected[0])}
                      options={employeeTypes}
                      placeholder="Choose an employee type..."
                      selected={empType ? [empType] : []}
                      className="form-control-hover"
                      labelKey="EmployeeTypeName"
                      // required
                    />
                  </Form.Group>
                </Col>
                <Col md={3}>
                  <Form.Group controlId="contractor">
                    <Form.Label>Contractor</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Contractor"
                      value={contractor}
                      onChange={(e) => setContractor(e.target.value)}
                      // required
                      className="form-control-hover"
                    />
                  </Form.Group>
                </Col>
                <Col md={3}>
                  <Form.Group controlId="report">
                    <Form.Label>Select Report</Form.Label>
                    <Form.Control
                      as="select"
                      value={report}
                      onChange={handleReportChange}
                      className="form-control-hover"
                      required
                    >
                      {/* <option value="0">Export To Excel (A4/2Pages)</option> */}
                      <option selected value="1">Export To Excel Format 2</option>
                      <option value="2">Export To Excel (Hariyana)</option>
                      <option value="3">Export To Excel (Contractor)</option>
                      <option value="4">Export To Excel (Shop Act.)</option>
                      <option value="5">Export To Excel (Delhi)</option>
                    </Form.Control>
                  </Form.Group>
                </Col>
                <Col md={3}>
                  <Form.Group controlId="sortBy">
                    <Form.Label>Sort By</Form.Label>
                    <InputGroup>
                      <Form.Control
                        as="select"
                        value={sortBy}
                        onChange={(e) => setSortBy (e.target.value)}
                        className="form-control-hover"
                        // required
                      >
                        <option value="DOFJOIN">Join Date</option>
                        <option value="EmployeeName">Name</option>
                        <option value="EmployeeSlNo">SL.NO</option>
                        <option value="EMPCODE">Code</option>
                      </Form.Control>
                      <InputGroup.Text
                        onClick={handleSortOrderToggle}
                        style={{ cursor: "pointer" }}
                      >
                        {isAscending ? <FaSortUp /> : <FaSortDown />}
                      </InputGroup.Text>
                    </InputGroup>
                  </Form.Group>
                </Col>
              </Row>

              <Row className="mb-3">
                {/* Report Type Section */}
                <Col xs={12} md={6} className="border p-3">
                  <Form.Group>
                    <Form.Label>
                      <div className="headline">Report Type</div>
                    </Form.Label>
                    <div className="d-flex justify-content-around">
                      <Form.Check
                        type="checkbox"
                        id="english"
                        name="language"
                        label="Show Salary Details"
                      
                        checked={showSalaryDetailChk === true}
                        onChange={(e) => setShowSalaryDetailChk(!showSalaryDetailChk)}
                        className="mx-2"
                      />
                      <Form.Check
                        type="checkbox"
                        id="hindi"
                        name="language"
                        label="Show only those are in salary sheet"
                       
                        checked={showOnlySalarySheetChk === true}
                        onChange={(e) => setShowOnlySalarySheetChk(!showOnlySalarySheetChk)}
                        className="mx-2"
                      />
                    </div>
                  </Form.Group>
                </Col>

                {/* Show Days Section */}
                <Col xs={12} md={6} className="border p-3">
                  <Form.Group>
                    <Form.Label>
                      <div className="headline">Show Days</div>
                    </Form.Label>
                    <div className="d-flex justify-content-around flex-wrap">
                      <Form.Check
                        type="checkbox"
                        id="workdays"
                        label="Work days"
                        checked={chkwd === "1"}
                        onChange={(e) => setChkwd(e.target.checked ? "1" : "0")}
                        className="mx-2"
                      />
                      <Form.Check
                        type="checkbox"
                        id="holiday"
                        label="Holiday"
                        checked={chkhd === "1"}
                        onChange={(e) => setChkhd(e.target.checked ? "1" : "0")}
                        className="mx-2"
                      />
                      <Form.Check
                        type="checkbox"
                        id="woff"
                        label="W. Off"
                        checked={chkwo === "1"}
                        onChange={(e) => setChkwo(e.target.checked ? "1" : "0")}
                        className="mx-2"
                      />
                      <Form.Check
                        type="checkbox"
                        id="cl"
                        label="CL"
                        checked={chkcl === "1"}
                        onChange={(e) => setChkcl(e.target.checked ? "1" : "0")}
                        className="mx-2"
                      />
                      <Form.Check
                        type="checkbox"
                        id="el"
                        label="EL"
                        checked={chkel === "1"}
                        onChange={(e) => setChkel(e.target.checked ? "1" : "0")}
                        className="mx-2"
                      />
                      <Form.Check
                        type="checkbox"
                        id="sl"
                        label="SL"
                        checked={chksl === "1"}
                        onChange={(e) => setChksl(e.target.checked ? "1" : "0")}
                        className="mx-2"
                      />
                    </div>
                  </Form.Group>
                </Col>
              </Row>

              <Row>
                <Col className="text-center">
                  <Button
                    type="submit"
                    variant="primary"
                    className="px-4"
                    disabled={isLoading || getOptionsLoading}
                  >
                    {isLoading || getOptionsLoading ? "Loading..." : "Print"}
                  </Button>
                </Col>
              </Row>
            </Form>
          </Row>
          <Row>
            <Col>
              <Table striped bordered hover responsive>
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Time of Commencement</th>
                    <th>From</th>
                    <th>To</th>
                    <th>From</th>
                    <th>To</th>
                    <th>Time of Completion</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      <Form.Group className="mb-3">
                        <p>Monday to Friday</p>
                      </Form.Group>
                    </td>
                    <td>
                      <Form.Group className="mb-3">
                        <Row>
                          <Col>
                            <Form.Control
                              type="time"
                              placeholder="From"
                              value={comMondayToFriday || "09:00"}
                              onChange={(e) =>
                                setComMondayToFriday(e.target.value)
                              }
                              required
                            />
                          </Col>
                        </Row>
                      </Form.Group>
                    </td>
                    <td>
                      <Form.Group className="mb-3">
                        <Row>
                          <Col>
                            <Form.Control
                              type="time"
                              placeholder="From"
                              value={fromMondayToFriday || "09:00"}
                              onChange={(e) =>
                                setFromMondayToFriday(e.target.value)
                              }
                              required
                            />
                          </Col>
                        </Row>
                      </Form.Group>
                    </td>
                    <td>
                      <Form.Group className="mb-3">
                        <Row>
                          <Col>
                            <Form.Control
                              type="time"
                              placeholder="From"
                              value={toMondayToFriday || "17:30"}
                              onChange={(e) =>
                                setToMondayToFriday(e.target.value)
                              }
                              required
                            />
                          </Col>
                        </Row>
                      </Form.Group>
                    </td>
                    <td>
                      <Form.Group className="mb-3">
                        <Row>
                          <Col>
                            <Form.Control
                              type="time"
                              placeholder="From"
                              value={fromMondayToFridaySecond || "13:30"}
                              onChange={(e) =>
                                setFromMondayToFridaySecond(e.target.value)
                              }
                              required
                            />
                          </Col>
                        </Row>
                      </Form.Group>
                    </td>
                    <td>
                      <Form.Group className="mb-3">
                        <Row>
                          <Col>
                            <Form.Control
                              type="time"
                              placeholder="From"
                              value={toMondayToFridaySecond || "17:30"}
                              onChange={(e) =>
                                setToMondayToFridaySecond(e.target.value)
                              }
                              required
                            />
                          </Col>
                        </Row>
                      </Form.Group>
                    </td>
                    <td>
                      <Form.Group className="mb-3">
                        <Row>
                          <Col>
                            <Form.Control
                              type="time"
                              placeholder="From"
                              value={compMondayToFridaySecond || "17:30"}
                              onChange={(e) =>
                                setCompMondayToFridaySecond(e.target.value)
                              }
                              required
                            />
                          </Col>
                        </Row>
                      </Form.Group>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <Form.Group className="mb-3">
                        <p>Saturday</p>
                      </Form.Group>
                    </td>
                    <td>
                      <Form.Group className="mb-3">
                        <Row>
                          <Col>
                            <Form.Control
                              type="time"
                              placeholder="From"
                              value={comSaturday || "09:00"}
                              onChange={(e) => setComSaturday(e.target.value)}
                              required
                            />
                          </Col>
                        </Row>
                      </Form.Group>
                    </td>
                    <td>
                      <Form.Group className="mb-3">
                        <Row>
                          <Col>
                            <Form.Control
                              type="time"
                              placeholder="From"
                              value={fromSaturday || "09:00"}
                              onChange={(e) => setFromSaturday(e.target.value)}
                              required
                            />
                          </Col>
                        </Row>
                      </Form.Group>
                    </td>
                    <td>
                      <Form.Group className="mb-3">
                        <Row>
                          <Col>
                            <Form.Control
                              type="time"
                              placeholder="From"
                              value={toSaturday || "17:30"}
                              onChange={(e) => setToSaturday(e.target.value)}
                              required
                            />
                          </Col>
                        </Row>
                      </Form.Group>
                    </td>
                    <td>
                      <Form.Group className="mb-3">
                        <Row>
                          <Col>
                            <Form.Control
                              type="time"
                              placeholder="From"
                              value={fromSaturdaySecond || "13:30"}
                              onChange={(e) =>
                                setFromSaturdaySecond(e.target.value)
                              }
                              required
                            />
                          </Col>
                        </Row>
                      </Form.Group>
                    </td>
                    <td>
                      <Form.Group className="mb-3">
                        <Row>
                          <Col>
                            <Form.Control
                              type="time"
                              placeholder="From"
                              value={toSaturdaySecond || "17:30"}
                              onChange={(e) =>
                                setToSaturdaySecond(e.target.value)
                              }
                              required
                            />
                          </Col>
                        </Row>
                      </Form.Group>
                    </td>
                    <td>
                      <Form.Group className="mb-3">
                        <Row>
                          <Col>
                            <Form.Control
                              type="time"
                              placeholder="From"
                              value={compSaturdaySecond || "17:30"}
                              onChange={(e) =>
                                setCompSaturdaySecond(e.target.value)
                              }
                              required
                            />
                          </Col>
                        </Row>
                      </Form.Group>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <Form.Group className="mb-3">
                        <p>Sunday</p>
                      </Form.Group>
                    </td>
                    <td>
                      <p>Weekly Off</p>
                    </td>
                    <td>
                      <p>Weekly Off</p>
                    </td>
                    <td>
                      <p>Weekly Off</p>
                    </td>
                    <td>
                      <p>Weekly Off</p>
                    </td>
                    <td>
                      <p>Weekly Off</p>
                    </td>
                    <td>
                      <p>Weekly Off</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>System Rotation of Relays</p>
                    </td>
                    <td colspan="6">
                      <Form.Group className="mb-3">
                        <Row>
                          <Col>
                            <Form.Control
                              type="text"
                              placeholder="System Rotation of Relays"
                              value={systemRotationRelays}
                              onChange={(e) =>
                                setSystemRotationRelays(e.target.value)
                              }
                              required
                            />
                          </Col>
                        </Row>
                      </Form.Group>
                    </td>
                  </tr>
                  <tr>
                    <td colspan="2">
                      <Form.Label>Head 1</Form.Label>
                      <Form.Group className="mb-3">
                        <Row>
                          <Col>
                            <Form.Control
                              type="text"
                              placeholder="Head 1"
                              value={headOne}
                              onChange={(e) => setHeadOne(e.target.value)}
                              required
                            />
                          </Col>
                        </Row>
                      </Form.Group>
                    </td>
                    <td colspan="2">
                      <Form.Label>Head 2</Form.Label>
                      <Form.Group className="mb-3">
                        <Row>
                          <Col>
                            <Form.Control
                              type="text"
                              placeholder="Head 2"
                              value={headTwo}
                              onChange={(e) => setHeadTwo(e.target.value)}
                              required
                            />
                          </Col>
                        </Row>
                      </Form.Group>
                    </td>
                    <td colspan="2">
                      <Form.Label>Head 3</Form.Label>
                      <Form.Group className="mb-3">
                        <Row>
                          <Col>
                            <Form.Control
                              type="text"
                              placeholder="Head 3"
                              value={headThree}
                              onChange={(e) => setHeadThree(e.target.value)}
                              required
                            />
                          </Col>
                        </Row>
                      </Form.Group>
                    </td>
                    <td>
                      <Form.Label>Head 4</Form.Label>
                      <Form.Group className="mb-3">
                        <Row>
                          <Col>
                            <Form.Control
                              type="text"
                              placeholder="Head 4"
                              value={headFour}
                              onChange={(e) => setHeadFour(e.target.value)}
                              required
                            />
                          </Col>
                        </Row>
                      </Form.Group>
                    </td>
                  </tr>
                </tbody>
              </Table>
            </Col>
          </Row>
        </Col>

        <Modal show={showModal} onHide={() => setShowModal(false)} size="lg">
          <Modal.Header closeButton>
            <Modal.Title>Salary Slip PDF</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <iframe
              src={pdfUrl}
              width="100%"
              height="500px"
              title="Salary Slip PDF"
            ></iframe>
          </Modal.Body>
        </Modal>
      </Container>
    </>
  );
};

export default AttendanceRegisterFormScreen;
